<template>
  <b-modal
    :title="
      `${
        investment.status != 'pending' ? 'Investment Details' : 'Payment details'
      }`
    "
    id="investment-details-modal"
    ref="investment-details-modal"
    centered
    ok-only
  >
    <div v-if="investment.status == 'pending'">
      <div class="modal-wrap">
        <b-row>
          <b-col cols="6">
            <small>Payment Date:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">
              {{
              LuxonDateTime.fromJSDate(
              new Date(investment.createdat)
              ).toFormat("LLL dd yyyy")
              }}
            </h6>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="modal-wrap">
        <b-row>
          <b-col cols="6">
            <small>Bank:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">{{ bankName(investment.payingbankcode) }}</h6>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="modal-wrap">
        <b-row>
          <b-col cols="6">
            <small>Payment Reference:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">{{ investment.reference }}</h6>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="modal-wrap">
        <b-row>
          <b-col>
            <small>Payment Proof</small>
          </b-col>
        </b-row>
      </div>
      <div class="modal-wrap">
        <b-row>
          <b-col>
            <div class="wrapper bg-light p-3 dash-card">
              <i class="fa fa-camera" aria-hidden="true"></i>
              <img
                class="d-block bg-white"
                :src="investment.paymentproof"
                style="width: 100%; height: auto; min-height:200px"
              />
            </div>
          </b-col>
        </b-row>
      </div>
      <hr />
    </div>
    <div v-else>
      <div cols="12" class="modal-wrap">
        <component class="text-black-50" :is="`${investment.type}-icon`" :size="40"></component>

        <b-row>
          <b-col cols="6">
            <small>Investment Code:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">{{ investment.code}}</h6>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div cols="12" class="modal-wrap" v-if="investment.type == 'crowd-funding'">
        <b-row>
          <b-col cols="6">
            <small>ROI:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">{{ investment.roi * 1 }}%</h6>
          </b-col>
        </b-row>
      </div>
      <div class="modal-wrap" v-else>
        <b-badge variant="primary">Co-Ownership</b-badge>
      </div>
      <hr />
      <div class="modal-wrap">
        <b-row>
          <b-col cols="6">
            <small>Purchase Date:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">
              {{
              LuxonDateTime.fromJSDate(
              new Date(investment.start)
              ).toFormat("LLL dd yyyy")
              }}
            </h6>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="modal-wrap">
        <b-row>
          <b-col cols="6">
            <small>Maturity Date:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">
              {{
              LuxonDateTime.fromJSDate(new Date(investment.maturity)).toFormat(
              "LLL dd yyyy"
              )
              }}
            </h6>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="modal-wrap">
        <b-row>
          <b-col cols="6">
            <small>Units Purchased:</small>
          </b-col>
          <b-col cols="6">
            <h6 class="mb-0">{{ parseInt(investment.amount) / 50000 }}</h6>
          </b-col>
        </b-row>
      </div>
      <hr />

      <div class="modal-wrap">
        <div class="wrapper py-3">
          <small>Total Amount</small>
          <Money :value="investment.amount || 0" />
        </div>
      </div>
      <div
        class="wrapper modal-wrap mb-4 py-4 bg-light dash-card"
        v-if="investment.type == 'crowd-funding'"
      >
        <small>Estimated returns</small>
        <Money
          class="text-primary"
          :value="
              Number(investment.amount) +
                (investment.amount * investment.roi) / 100
            "
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import nigerianBanks from "@/utils/nigerianBanks";

export default {
  data() {
    return {
      LuxonDateTime: LuxonDateTime
    };
  },
  props: {
    investment: null
  },
  methods: {
    bankName(code) {
      // console.log()
      return nigerianBanks[code];
    }
  }
};
</script>


